import React, { useEffect, useState } from "react";
import ApiServices from "../../services/apiServices";
import storage from "../../services/storage";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import "./index.css";

import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import Mask from "../../services/mask";
import { Navigate, useNavigate, useParams } from "react-router";
import { Box, Button, Modal, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SentimentVeryDissatisfiedIcon from "@mui/icons-material/SentimentVeryDissatisfied";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ClearIcon from "@mui/icons-material/Clear";
import ImgLoja from "../../assets/images/pngs/shop.png";
import { useLoad } from "../../context";
import DuploFator from "../../Components/DuploFator";
import { toast } from "react-toastify";
import { filterProductsByUserCategory } from "../../utils/categoryFilter";
import CardProduto from "../../Components/CardProduto";
import escudo from "../../assets/images/pngs/escudo.png";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Pagination } from "swiper";
import { FiAlertTriangle } from "react-icons/fi";

export default function Produto() {
  const [user] = useState(storage.get("USUARIO")?.loginResponse);
  const [saldo, setSaldo] = useState(0);
  const [mostrarSaldo, setMostrarSaldo] = useState(false);
  const [produto, setProduto] = useState({});
  const paramsId = useParams().id;
  const [quantidade, setQuantidade] = useState(1);
  const [tipoModal, setTipoModal] = useState(0);
  const [vouchers, setVouchers] = useState(0);
  const { load, setLoad } = useLoad();
  const navigate = useNavigate();
  const [abrirDuploFator, setAbrirDuploFator] = useState(false);
  const [tokenAcesso, setTokenAcesso] = useState("");
  const [verificaAntes, setVerificaAntes] = useState(true);
  const [verificaFechamento, setVerificaFechamento] = useState(null);
  const categoriaProdutoEscolaDaMarcenaria =
    "98af45ca-12f1-430e-b6d2-1336dda30d5a";
  const categoriaProdutoViagemTimeDeCraques =
    "c8fc5f10-1c25-4844-9aef-524c3b485b80";
  const [produtosRecomendados, setProdutosRecomendados] = useState([]);

  async function fnCarregarSaldo() {
    var init = {
      token: user.token,
      mes: "",
      ano: "",
    };
    try {
      let response = await ApiServices.apiPost("vitrineorder/saldo", init);
      setSaldo(response.data.balance);
    } catch (err) {
      console.error("err", err);
    } finally {
    }
  }

  async function fnResgatar() {
    var init = {
      points: produto.pontos,
      productId: produto.produtoId,
      produtoResgate: {
        description: produto.titulo,
        points: produto.pontos,
        productId: produto.sku,
        qtde: Number(quantidade),
      },
      CodigoDuploFator: tokenAcesso,
    };

    try {
      setLoad(true);
      let response = await ApiServices.apiPostResgate("produto/resgate", init);
      const data = await response.json();

      if (data.statusCode == 200) {
        if (
          produto.produtoCategoria.produtoCategoriaId ===
          categoriaProdutoEscolaDaMarcenaria
        ) {
          setTipoModal(3); // Definindo o tipo de modal para 3 se a categoria corresponder
          setTimeout(() => {
            window.location.href =
              "https://cursos.escola.leosocial.org.br/amigo-leo"; // Coloque aqui o link para redirecionar
          }, 8000); // Espera de 6 segundos
        } else if (
          produto.produtoCategoria.produtoCategoriaId ===
          categoriaProdutoViagemTimeDeCraques
        ) {
          setTipoModal(4);
        } else {
          setTipoModal(2); // Caso contrário, continua com o tipo de modal 2
        }

        setAbrirDuploFator(false);
        setVouchers(data.data.token);
      } else {
        toast.error(data.message);
        setAbrirDuploFator(false);

        if (data.data.token !== "null") {
          setTipoModal(1);
        }
      }
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnProduto() {
    try {
      setLoad(true);
      let response = await ApiServices.apiGet(
        "produto/de-produto-detalhe/" + paramsId,
      );

      // Check if user has access to this product based on categories
      const filteredProducts = filterProductsByUserCategory([response.data]);

      if (filteredProducts.length === 0) {
        // User doesn't have access to this product, redirect back
        navigate("/catalogo/vitrine-leo");
        return;
      }

      setProduto(response.data);
    } catch (err) {
      console.error("err", err);
    } finally {
      setLoad(false);
    }
  }

  async function fnListaProdutosRecomendados() {
    if (!produto?.produtoId) return;

    try {
      let response = await ApiServices.apiGet(
        `produto/de-produto?disponivel=true&descricao=&categoriaId=${
          produto?.produtoCategoria?.produtoCategoriaId || ""
        }&pontos=1&sku=`,
      );
      const filteredProducts = filterProductsByUserCategory(response.data);
      // Filtrar o produto atual e pegar apenas 5 produtos
      const produtosFiltrados = filteredProducts
        .filter((p) => p.produtoId !== produto.produtoId)
        .slice(0, 5);
      setProdutosRecomendados(produtosFiltrados);
    } catch (err) {
      console.error("err", err);
    }
  }
  function fnMostrarSaldo() {
    if (mostrarSaldo) {
      setMostrarSaldo(false);
    } else {
      setMostrarSaldo(true);
      fnCarregarSaldo();
    }
  }

  function getQuantidadeLimitada(quantidadeNova) {
    quantidadeNova = Number(quantidadeNova);

    if (
      produto.quantoPodeResgatar !== null &&
      quantidadeNova > produto.quantoPodeResgatar
    )
      quantidadeNova = produto.quantoPodeResgatar;

    return quantidadeNova;
  }

  useEffect(() => {
    fnCarregarSaldo();
    fnProduto();
    setQuantidade(1); // Resetar quantidade ao mudar de produto
    setProdutosRecomendados([]); // Limpar produtos recomendados ao mudar de produto
    window.scrollTo(0.0, 0.0);
  }, [paramsId]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (produto?.produtoId) {
      fnListaProdutosRecomendados();
    }
  }, [produto?.produtoId]); //eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (tokenAcesso != "") {
      fnResgatar();
    }
  }, [tokenAcesso]);
  // useEffect(() => {
  //   if (abrirDuploFator) {
  //     fnResgatar();
  //   }
  // }, [abrirDuploFator]);

  return (
    <div>
      {abrirDuploFator && (
        <DuploFator
          setAbrirDuploFator={setAbrirDuploFator}
          setTokenAcesso={setTokenAcesso}
          setVerificaAntes={setVerificaAntes}
          setVerificaFechamento={setVerificaFechamento}
        />
      )}

      <div className="d-flex justify-content-center mt-3">
        <div className="container containerProduto">
          {/* Breadcrumbs */}
          {produto?.titulo && (
            <div className="breadcrumbContainer">
              <button
                className="breadcrumbLink"
                onClick={() => navigate("/home")}
              >
                <ArrowBackIosIcon style={{ fontSize: 14 }} />
                Home
              </button>
              <span className="breadcrumbSeparator">/</span>
              <button
                className="breadcrumbLink"
                onClick={() => navigate("/catalogo/vitrine-leo")}
              >
                Catálogo
              </button>
              {produto?.produtoCategoria?.categoria && (
                <>
                  <span className="breadcrumbSeparator">/</span>
                  <span className="breadcrumbCurrent">
                    {produto.produtoCategoria.categoria}
                  </span>
                </>
              )}
              <span className="breadcrumbSeparator">/</span>
              <span className="breadcrumbCurrent">{produto.titulo}</span>
            </div>
          )}

          <div className="row d-flex justify-content-center">
            <div className="col-md-12">
              {/* Seção Principal do Produto */}
              {produto?.produtoId && (
                <div className="row d-flex justify-content-center produtoMainSection">
                  <div className="col-md-6 col-12 produtoImagemContainer">
                    <div className="produtoImagemWrapper">
                      <img
                        className="produtoImagem"
                        src={produto.urlImagem || ""}
                        alt={produto.titulo || "Produto"}
                      />
                    </div>
                  </div>

                  <div className="col-md-6 col-12 produtoInfoContainer">
                    <div className="produtoInfo">
                      <div className="produtoRef">Ref: {produto.sku}</div>
                      <h1 className="produtoTitulo">{produto.titulo}</h1>
                      {produto.subtitulo && (
                        <h2 className="produtoSubtitulo">
                          {produto.subtitulo}
                        </h2>
                      )}

                      {/* Preço com desconto (se houver) */}
                      {produto?.valorAtual &&
                      produto?.campanhaStatus?.nome == "Em andamento" ? (
                        <div className="produtoPrecoDesconto">
                          <div className="precoLabel">De:</div>
                          <div className="precoAntigo">
                            {Mask.numeroPontos(produto.valorAtual?.toString())}{" "}
                            PONTOS
                          </div>
                        </div>
                      ) : null}

                      {/* Preço atual */}
                      <div className="produtoPreco">
                        <div className="precoLabel">
                          Resgate esse produto por
                        </div>
                        <div className="precoValor">
                          {Mask.numeroPontos(produto.pontos?.toString())}
                        </div>
                        <div className="precoUnidade">PONTOS</div>
                      </div>

                      {/* Seletor de quantidade */}
                      {(produto.quantoPodeResgatar === null ||
                        produto.quantoPodeResgatar > 0) && (
                        <div className="produtoQuantidade">
                          <label className="quantidadeLabel">Quantidade</label>
                          <div className="quantidadeControls">
                            <button
                              className="quantidadeBtn"
                              onClick={() =>
                                setQuantidade((prev) =>
                                  Number(prev) > 1 ? Number(prev) - 1 : 1,
                                )
                              }
                            >
                              <RemoveIcon />
                            </button>
                            <input
                              className="quantidadeInput"
                              type="text"
                              value={quantidade}
                              onChange={(e) => {
                                const value = e.target.value;
                                if (value[0] == "0") {
                                  setQuantidade(
                                    getQuantidadeLimitada(
                                      value.slice(1) || "1",
                                    ),
                                  );
                                } else {
                                  setQuantidade(
                                    getQuantidadeLimitada(
                                      value >= 1 ? value : "1",
                                    ),
                                  );
                                }
                              }}
                            />
                            <button
                              className="quantidadeBtn"
                              onClick={() =>
                                setQuantidade((prev) =>
                                  getQuantidadeLimitada(Number(prev) + 1),
                                )
                              }
                            >
                              <AddIcon />
                            </button>
                          </div>
                          <div className="pontosNecessarios">
                            <span className="pontosNecessariosLabel">
                              Pontos necessários:
                            </span>
                            <span className="pontosNecessariosValor">
                              {Mask.numeroPontos(
                                (produto.pontos * quantidade)?.toString(),
                              )}{" "}
                              PONTOS
                            </span>
                          </div>
                        </div>
                      )}

                      {/* Botões de ação */}
                      <div className="produtoAcoes">
                        <button
                          className="btn btn-secondary btnVoltar"
                          onClick={() => {
                            navigate("/catalogo/vitrine-leo");
                          }}
                        >
                          VOLTAR
                        </button>

                        {produto.quantoPodeResgatar !== null &&
                          produto.quantoPodeResgatar <= 0 && (
                            <div className="limiteAtingido">
                              <h5>Limite máximo de resgate já atingido.</h5>
                            </div>
                          )}

                        {(produto.quantoPodeResgatar === null ||
                          produto.quantoPodeResgatar > 0) && (
                          <>
                            {!storage.get("gestaoMenu")?.voucher && (
                              <button
                                className="btn btn-warning btnResgatar"
                                onClick={() => {
                                  setAbrirDuploFator(true);
                                }}
                              >
                                RESGATAR
                              </button>
                            )}
                          </>
                        )}
                      </div>

                      {/* Informação de retirada */}
                      <div className="produtoInfoRetirada">
                        {produto?.produtoCategoria?.produtoCategoriaId ===
                        categoriaProdutoEscolaDaMarcenaria ? (
                          <div className="infoRetiradaContent">
                            <div>
                              Ao resgatar este produto, será gerado um voucher
                              para utilização no site da Escola da Marcenaria.{" "}
                              <a
                                href="https://escola.leosocial.org.br/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="infoRetiradaLink"
                              >
                                https://escola.leosocial.org.br/
                              </a>
                            </div>
                          </div>
                        ) : produto?.produtoCategoria?.produtoCategoriaId ===
                          categoriaProdutoViagemTimeDeCraques ? (
                          <div className="infoRetiradaContent">
                            <img
                              className="infoRetiradaIcon"
                              src={escudo}
                              alt="Time de Craques"
                            />
                            <div>
                              Ao resgatar este produto, será gerado um voucher
                              para identificação junto à equipe responsável, que
                              entrará em contato para detalhes da viagem.
                              Lembrando que este resgate{" "}
                              <b style={{ textDecoration: "underline" }}>não</b>{" "}
                              poderá ser cancelado.
                            </div>
                          </div>
                        ) : (
                          <div className="infoRetiradaContent infoRetiradaContentLoja">
                            <FiAlertTriangle style={{ fontSize: 80, color: "#0f5132" }} />
                            <div className="infoRetiradaTextoLoja">
                              Este produto deverá ser retirado em uma das lojas
                              Leo Madeiras. Antes de realizar o resgate,
                              consulte se ele está disponível na loja mais
                              próxima.
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* Seção de Informações do Produto */}
              <div className="produtoInformacoes">
                {produto.descricao && (
                  <div className="infoSection">
                    <h4 className="infoSectionTitulo">Destaques</h4>
                    <div className="infoSectionConteudo">
                      {produto.descricao.split("\n").map((paragrafo, index) => (
                        <p key={index}>{paragrafo}</p>
                      ))}
                    </div>
                  </div>
                )}

                {produto.capacidade && (
                  <div className="infoSection">
                    <h4 className="infoSectionTitulo">Especificações</h4>
                    <div className="infoSectionConteudo">
                      {produto.capacidade.split("\n").map((item, index) => (
                        <div key={index} className="especificacaoItem">
                          • {item}
                        </div>
                      ))}
                    </div>
                  </div>
                )}

                {produto.caracteristicas && (
                  <div className="infoSection">
                    <h4 className="infoSectionTitulo">Características</h4>
                    <div className="infoSectionConteudo">
                      {produto.caracteristicas
                        .split("\n")
                        .map((paragrafo, index) => (
                          <p key={index}>{paragrafo}</p>
                        ))}
                    </div>
                  </div>
                )}

                {produto.aplicacoes && (
                  <div className="infoSection">
                    <h4 className="infoSectionTitulo">Aplicações</h4>
                    <div className="infoSectionConteudo">
                      {produto.aplicacoes
                        .split("\n")
                        .map((paragrafo, index) => (
                          <p key={index}>{paragrafo}</p>
                        ))}
                    </div>
                  </div>
                )}
              </div>

              {/* Seção de Produtos Recomendados */}
              {produtosRecomendados.length > 0 && (
                <div className="produtosRecomendadosSection pt-4">
                  <h3 className="recomendadosTitulo">Recomendados para você</h3>
                  {/* Versão Desktop - Grid */}
                  <div className="recomendadosContainer recomendadosDesktop">
                    {produtosRecomendados.map((produtoRec, index) => (
                      <CardProduto
                        key={index}
                        product={produtoRec}
                        customRoute={`/catalogo/vitrine-leo/${produtoRec.produtoId}`}
                      />
                    ))}
                  </div>
                  {/* Versão Mobile - Swiper */}
                  <div className="recomendadosContainer recomendadosMobile">
                    <Swiper
                      slidesPerView={1.5}
                      spaceBetween={12}
                      pagination={{
                        clickable: true,
                      }}
                      navigation={true}
                      loop={true}
                      modules={[Navigation, Pagination]}
                      className="recomendadosSwiper"
                      breakpoints={{
                        320: {
                          slidesPerView: 1.5,
                          spaceBetween: 12,
                        },
                        480: {
                          slidesPerView: 2.5,
                          spaceBetween: 16,
                        },
                      }}
                    >
                      {produtosRecomendados.map((produtoRec, index) => (
                        <SwiperSlide key={index}>
                          <CardProduto
                            product={produtoRec}
                            customRoute={`/catalogo/vitrine-leo/${produtoRec.produtoId}`}
                          />
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* MODAL */}
      {/* MODAL */}
      {/* MODAL */}
      <Modal
        keepMounted
        open={tipoModal != 0}
        onClose={() => setTipoModal(0)}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box className="configModal">
          <div className="d-flex justify-content-end pointer">
            <CloseIcon
              onClick={() =>
                tipoModal === 2 || tipoModal === 4
                  ? navigate("/catalogo/vitrine-leo")
                  : setTipoModal(0)
              }
            />
          </div>
          {tipoModal == 1 && (
            <div
              style={{
                textAlign: "center",
                minWidth: 400,
                maxWidth: 500,
                color: "#222",
                padding: "20px",
              }}
            >
              {/* Título de Erro */}
              <div
                style={{
                  color: "#dc3545",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 16,
                }}
              >
                Que pena! Você não tem pontos suficientes
              </div>

              {/* Ícone de Erro */}
              <SentimentVeryDissatisfiedIcon
                style={{ color: "#dc3545", fontSize: 80, marginBottom: 20 }}
              />

              {/* Mensagem Principal */}
              <div
                style={{
                  fontSize: 16,
                  color: "#666",
                  marginBottom: "24px",
                  lineHeight: "1.5",
                }}
              >
                Para resgatar este produto você precisa de mais pontos.
              </div>

              {/* Aviso de Incentivo */}
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "1px solid #dee2e6",
                  borderRadius: "8px",
                  padding: "16px",
                  margin: "20px 0",
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: "#495057",
                    marginBottom: "8px",
                  }}
                >
                  💡 DICA
                </div>
                <div
                  style={{
                    fontSize: 15,
                    color: "#495057",
                    lineHeight: "1.4",
                  }}
                >
                  Continue comprando para juntar mais pontos e resgatar este
                  produto!
                </div>
              </div>
            </div>
          )}
          {tipoModal == 2 && (
            <div
              style={{
                textAlign: "center",
                minWidth: 400,
                maxWidth: 500,
                color: "#222",
                padding: "20px",
              }}
            >
              {/* Título de Sucesso */}
              <div
                style={{
                  color: "#28a745",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 16,
                }}
              >
                Parabéns! Resgate efetuado com sucesso
              </div>

              {/* Ícone de Sucesso */}
              <CheckCircleOutlineIcon
                style={{ color: "#28a745", fontSize: 80, marginBottom: 20 }}
              />

              {/* Número do Voucher */}
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "2px solid #28a745",
                  borderRadius: "8px",
                  padding: "16px",
                  margin: "20px 0",
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#666",
                    marginBottom: "8px",
                  }}
                >
                  NÚMERO DO VOUCHER:
                </div>
                <div
                  style={{
                    fontSize: 20,
                    fontWeight: 900,
                    color: "#28a745",
                    letterSpacing: "2px",
                  }}
                >
                  {vouchers}
                </div>
              </div>

              {/* Instruções */}
              <div
                style={{
                  fontSize: 14,
                  color: "#666",
                  marginBottom: "24px",
                  lineHeight: "1.5",
                }}
              >
                Anote este número e apresente ao vendedor ou confira seus
                resgates na seção <strong>Extrato/Meus Vouchers</strong>.
              </div>

              {/* Aviso de Validade */}
              <div
                style={{
                  backgroundColor: "#fff3cd",
                  border: "1px solid #ffeaa7",
                  borderRadius: "8px",
                  padding: "16px",
                  margin: "20px 0",
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#856404",
                    marginBottom: "8px",
                  }}
                >
                  ⏰ PRAZO DE VALIDADE
                </div>
                <div
                  style={{
                    fontSize: 15,
                    color: "#856404",
                    lineHeight: "1.4",
                  }}
                >
                  Resgate seu produto em uma loja Leo Madeiras em até{" "}
                  <strong style={{ textDecoration: "underline" }}>
                    45 dias
                  </strong>
                  . Após esse período, seu voucher será expirado.
                </div>
              </div>

              {/* Aviso de Cancelamento */}
              <div
                style={{
                  fontSize: 14,
                  color: "#6c757d",
                  fontStyle: "italic",
                  marginTop: "16px",
                }}
              >
                Lembrando que o prazo para cancelamento do item é de{" "}
                <strong>7 dias</strong>
              </div>
            </div>
          )}
          {tipoModal == 3 && (
            <div
              style={{
                textAlign: "center",
                minWidth: 400,
                maxWidth: 500,
                color: "#222",
                padding: "20px",
              }}
            >
              {/* Título de Sucesso */}
              <div
                style={{
                  color: "#28a745",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 16,
                }}
              >
                Parabéns! Resgate efetuado com sucesso
              </div>

              {/* Ícone de Sucesso */}
              <CheckCircleOutlineIcon
                style={{ color: "#28a745", fontSize: 80, marginBottom: 20 }}
              />

              {/* Número do Voucher */}
              <div
                style={{
                  backgroundColor: "#f8f9fa",
                  border: "2px solid #28a745",
                  borderRadius: "8px",
                  padding: "16px",
                  margin: "20px 0",
                }}
              >
                <div
                  style={{
                    fontSize: 14,
                    fontWeight: 600,
                    color: "#666",
                    marginBottom: "8px",
                  }}
                >
                  CÓDIGO DE ACESSO:
                </div>
                <div
                  style={{
                    fontSize: 20,
                    fontWeight: 900,
                    color: "#28a745",
                    letterSpacing: "2px",
                  }}
                >
                  {vouchers}
                </div>
              </div>

              {/* Instruções de Redirecionamento */}
              <div
                style={{
                  fontSize: 16,
                  color: "#666",
                  marginBottom: "24px",
                  lineHeight: "1.5",
                }}
              >
                Aguarde, você será direcionado para página da escola em alguns
                instantes. Para confirmar seus dados, digite o código acima.
              </div>

              {/* Aviso de Validade */}
              <div
                style={{
                  backgroundColor: "#fff3cd",
                  border: "1px solid #ffeaa7",
                  borderRadius: "8px",
                  padding: "16px",
                  margin: "20px 0",
                }}
              >
                <div
                  style={{
                    fontSize: 16,
                    fontWeight: 700,
                    color: "#856404",
                    marginBottom: "8px",
                  }}
                >
                  ⏰ PRAZO DE VALIDADE
                </div>
                <div
                  style={{
                    fontSize: 15,
                    color: "#856404",
                    lineHeight: "1.4",
                  }}
                >
                  Resgate seu produto em uma loja Leo Madeiras em até{" "}
                  <strong style={{ textDecoration: "underline" }}>
                    45 dias
                  </strong>
                  . Após esse período, seu voucher será expirado.
                </div>
              </div>

              {/* Aviso de Cancelamento */}
              <div
                style={{
                  fontSize: 14,
                  color: "#6c757d",
                  fontStyle: "italic",
                  marginTop: "16px",
                }}
              >
                Lembrando que o prazo para cancelamento do voucher é de{" "}
                <strong>7 dias úteis</strong>
              </div>
            </div>
          )}
          {tipoModal == 4 && (
            <div
              className="d-flex flex-column align-items-center justify-content-center"
              style={{
                padding: "32px 16px",
                background: "#f8f9fa",
                borderRadius: 16,
                boxShadow: "0 2px 16px rgba(0,0,0,0.08)",
                minWidth: 350,
                maxWidth: 500,
                margin: "0 auto",
              }}
            >
              <div
                style={{
                  color: "#3CB043",
                  fontWeight: 700,
                  fontSize: 24,
                  marginBottom: 8,
                  textAlign: "center",
                }}
              >
                É GOL! Parabéns! Resgate efetuado com sucesso
              </div>
              <img
                src={escudo}
                alt="Time de Craques"
                style={{ width: 90, margin: "12px 0" }}
              />
              <div
                style={{
                  background: "#fff",
                  border: "2px dashed #3CB043",
                  borderRadius: 10,
                  padding: "18px 24px",
                  margin: "16px 0 24px 0",
                  fontSize: 22,
                  fontWeight: 900,
                  color: "#3CB043",
                  letterSpacing: 2,
                  textAlign: "center",
                }}
              >
                Voucher:{" "}
                <span style={{ fontFamily: "monospace" }}>{vouchers}</span>
              </div>
              <div
                style={{
                  color: "#3CB043",
                  fontSize: 15,
                  margin: "18px 0 0 0",
                  fontWeight: 500,
                  textAlign: "center",
                  maxWidth: 400,
                }}
              >
                Você resgatou uma viagem para o maior campeonato de futebol do
                mundo. Em breve, nosso time entrará em contato para detalhes.
                Tenha em mãos o voucher gerado.
              </div>
              <div
                style={{
                  width: "100%",
                  margin: "18px 0",
                  borderTop: "1px solid #e0e0e0",
                }}
              />
              <div
                style={{
                  fontSize: 13,
                  color: "#222",
                  marginTop: 10,
                  fontWeight: 400,
                  textAlign: "center",
                }}
              >
                Lembrando que este resgate{" "}
                <b style={{ textDecoration: "underline" }}>não</b> poderá ser
                cancelado.
              </div>
            </div>
          )}
        </Box>
      </Modal>
    </div>
  );
}
